

import { useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider } from "react-router";
import Customer from "../../pages/customer";
import { Operation } from "../../pages/customer/operation";
import DashboardAdmin from "../../pages/dashboard";
import InvoiceAmount from "../../pages/invoicing";
import { Partition } from "../../pages/invoicing/partition";
import User from "../../pages/user";
import { setMenuItems } from "../../ui/layout/slice";
import { SpinnerComponent } from "../../ui/molecules/spinner";
import { MenuItems } from "../../ui/organisms/sidebar/dto";
import { keycloak } from "../keycloak";
import { useAppDispatch, useAppSelector } from "../redux/hook";


const adminRouter = createBrowserRouter([
    {
        path: '/',
        element: (
            <DashboardAdmin />
        ),
    },
    {
        path: '/customer',
        element: (
            <Customer />
        ),
    },
    {
        path: '/customer/:id',
        element: (
            <Operation />
        )
    },
    {
        path: '/users',
        element: (
            <User />
        )
    },
    {
        path: '/invoice-amount',
        element: (
            <InvoiceAmount />
        )
    },
    {
        path: '/invoice-amount/:id',
        element: (
            <Partition />
        )
    },
    {
        path: '*',
        element: <DashboardAdmin />
    }
])

const operatorRouter = createBrowserRouter([
    {
        path: '/',
        element: (
            <DashboardAdmin />
        ),
    },
    {
        path: '/customer',
        element: (
            <Customer />
        ),
    },
    {
        path: '/customer/:id',
        element: (
            <Operation />
        )
    },
    {
        path: '/users',
        element: (
            <User />
        )
    },
    {
        path: '/invoice-amount',
        element: (
            <Partition />
        )
    },
    {
        path: '/invoice-amount/:id',
        element: (
            <Operation />
        )
    },
    {
        path: '*',
        element: <DashboardAdmin />
    }
])

export function KeycloakRouter() {
    const roles = useAppSelector(state => state.secured.userRoles)
    const dispatch = useAppDispatch()

    const [router, setRouter] = useState<ReturnType<typeof createBrowserRouter> | undefined>(undefined)

    useEffect(() => {
        if (roles !== undefined && roles.length > 0 && keycloak.token !== undefined) {
            if (keycloak.hasRealmRole('admin')) {
                setRouter(adminRouter)
                dispatch(setMenuItems([
                    MenuItems.DASHBOARD,
                    MenuItems.LISTING,
                    MenuItems.USERS,
                    MenuItems.INVOICEAMOUNT
                ]))
            } else if (keycloak.hasRealmRole('operator')) {
                setRouter(operatorRouter)
                dispatch(setMenuItems([
                    MenuItems.DASHBOARD,
                    MenuItems.LISTING,
                    MenuItems.USERS,
                    MenuItems.INVOICEAMOUNT
                ]))
            }
        }
    }, [roles, keycloak.token])

    if (router === undefined) {
        return (
            <div className={"flex justify-center items-center w-full h-[100vh]"}>
                <SpinnerComponent />
            </div>
        )
    }

    return (
        <RouterProvider router={router} />
    );
}
